import { render, staticRenderFns } from "./DeleteNew.vue?vue&type=template&id=5857d940"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5857d940')) {
      api.createRecord('5857d940', component.options)
    } else {
      api.reload('5857d940', component.options)
    }
    module.hot.accept("./DeleteNew.vue?vue&type=template&id=5857d940", function () {
      api.rerender('5857d940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DeleteNew.vue"
export default component.exports